/* eslint-disable import/default */

import React from 'react';
import {render} from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { getRoutes } from './routes/routes';
import configureStore from './store/configureStore';
require('./.htaccess');
require('./favicon.ico'); // Tell webpack to load favicon.ico
import './customjs/bootstrap-toggle';
import './customjs/font-awesome';
import './styles/styles.scss';
import './styles/react-datetime.css';
import { syncHistoryWithStore } from 'react-router-redux';

const store = configureStore();

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

render(
  <Provider store={store}>
    <Router history={history}>
        {getRoutes(store)}
    </Router>
  </Provider>, document.getElementById('app')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/